<template>
    <div class="omnimapx__wrapper">
      <input ref="autocomplete" id="autocomplete" placeholder="Search Address" class="omnimapx__search" />
        <!--<div>{{ JSON.stringify([pois]) }}</div>-->
        <gmaps-map @mounted="ready" :options="mapOptions">
          <gmaps-marker
            v-for="(poi, index) in pois"
            :key="(poi.randcode || poi.id || 'poi') + '_' + index"
            :position="poi.info.coords"
            :options="getMarkerOptions(poi)"
            :zIndex="poi.zIndex || 4000"
            :label="getMarkerLabel(poi)"
            @click="focusAppointment(poi)"
          />
            <!--<gmaps-marker 
              :position="markerPos" 
              :options="markerOptions"
              @dragend="markerdrag"
            />-->
            <!--<template v-for="(routepoi, index) in technicianpois">
                <gmaps-marker v-if="(focusedpoi==null || focusedpoi.id != routepoi.id)"  :key="routepoi.id+'_route'"
                    :position="routepoi.info.coords" 
                    :options="{icon: markers.route}"    
                    :zIndex="4000"                   
                    :label="(index+1).toString()"
                    @click="focusAppointment(routepoi)"           
                />
                <gmaps-marker v-else-if="(focusedpoi!=null && focusedpoi.id == routepoi.id)" :key="routepoi.id+'_route2'"
                    :position="routepoi.info.coords" 
                    :options="{icon: markers.route_focused}"                               
                    :zIndex="9000"
                    :label="(index+1).toString()"
                    @click="focusAppointment(routepoi)"
                /> 
            </template>-->
            <!--<template v-for="(poi, index) in pois">
                <gmaps-marker v-if="poi.route==true && (focusedpoi==null || focusedpoi.id != poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.route}"    
                    :zIndex="4000"                   
                    :label="(poi.orderno).toString()"
                    @click="focusAppointment(poi)"           
                />
                <gmaps-marker v-else-if="poi.route==true && (focusedpoi!=null && focusedpoi.id == poi.id)" :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.route_focused}"                               
                    :zIndex="9000"
                    :label="(poi.orderno).toString()"
                    @click="focusAppointment(poi)"
                />
                <gmaps-marker v-if="poi.route==false && poi.startplace"  :key="'startplace_' + poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.start}" 
                    :zIndex="8000"        
                /> 
                <gmaps-marker v-else-if="poi.route==false && !poi.selected && (focusedpoi==null || focusedpoi.id != poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers[poi.info.marker]}"                       
                    @click="focusAppointment(poi)"           
                />
                <gmaps-marker v-else-if="poi.route==false && !poi.selected && (focusedpoi!=null && focusedpoi.id == poi.id)" :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers[poi.info.marker + '_focused']}"                               
                    :zIndex="5000"
                    @click="focusAppointment(poi)"
                />                
                <gmaps-marker v-else-if="poi.route==false && poi.selected && (focusedpoi==null || focusedpoi.id != poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.selected}"   
                    :zIndex="3000"
                    @click="focusAppointment(poi)"           
                />
                <gmaps-marker v-else-if="poi.route==false && poi.selected && (focusedpoi!=null && focusedpoi.id == poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.selected_focused}" 
                    :zIndex="8000"  
                    @click="focusAppointment(poi)"           
                />          
            </template>-->          
        </gmaps-map>      
    </div>
</template>
<script>
import { gmaps, gmapsMap, gmapsMarker } from 'x5-gmaps';

const markerss = {
    normal: require("src/assets/images/marker_normal.svg"),
    normal_focused: require("src/assets/images/marker_normal_focused.svg"),
    selected: require("src/assets/images/marker_selected.svg"),
    selected_focused: require("src/assets/images/marker_selected_focused.svg"),
    route: require("src/assets/images/marker_route.svg"),
    route_focused: require("src/assets/images/marker_route_focused.svg"),
    start: require("src/assets/images/marker_start.svg"),
};

export default {
  components: { gmapsMap, gmapsMarker },

  props: {   
        pois: {
            type: Array,
            default: () => [],
        },
        // technicianpois: {
        //     type: Array,
        //     default: () => [],
        // },
        focusedpoi: {
            type: Object,
            default: null,
        },
        fullheight: {
            type: Boolean,
            default: () => false,
        },     
        pinCoords: {
            type: Object,
            default: () => ({
                lat: undefined,
                lng: undefined
            }),
        }
    },

  data: () => ({
    autocomplete: null,
    places: null,
    map: null,
    mapsApi: null,
    markerPos: {lat: 28, lng: 24}, //{ lat: (this.pinCoords && this.pinCoords.lat ? this.pinCoords.lat : 38), lng: (this.pinCoords && this.pinCoords.lng ? this.pinCoords.lng : 24) }, //, 
    resultInfo: null,
    markers: markerss,

    markerOptions: {      
      icon: require("src/assets/images/marker_normal.svg"),
      start: require("src/assets/images/marker_start.svg")
    },

    mapOptions: {
      center: { lat: 37.9833, lng: 23.7278 },  //37.983388802468056, 23.727867248733407
      zoom: 10,      
      language: "gr"
    }
  }),
  watch: {
    pois: {
      handler(newPois) {
        this.$nextTick(() => {
          this.fitToMarkers(newPois);
        });
      },
      deep: true,
    }
  },
  methods: {
    ready(map) {
      this.map = map
      gmaps().then((maps) => {
        this.mapsApi = maps;
        this.places = new maps.places.PlacesService(map);
        this.autocomplete = new maps.places.Autocomplete(this.$refs.autocomplete);
        this.autocomplete.addListener('place_changed', this.searchResultSelected);
        this.fitToMarkers(this.pois);

      })
    },
    searchResultSelected() {
        const place = this.autocomplete.getPlace()
        if (place.geometry) {
            this.map.panTo(place.geometry.location)
            this.markerPos = place.geometry.location
        }       
        let rslt = this.extractAddress(place);
        this.$emit('onresult', rslt); 
        this.resultInfo = rslt;
    },

    extractAddress(placeResult) {    
      let addressComponents = placeResult.address_components;
      let rslt = {};      
      if(placeResult.address_components) {
        rslt['streetaddress']= this.extractPropertyFromGeocodingResults(addressComponents, "route") + " " + this.extractPropertyFromGeocodingResults(addressComponents, "street_number");
        rslt['municipality']= this.extractPropertyFromGeocodingResults(addressComponents, "locality");
        rslt['postalcode']= this.extractPropertyFromGeocodingResults(addressComponents, "postal_code");
        rslt['prefecture']= this.extractPropertyFromGeocodingResults(addressComponents, "administrative_area_level_3");
        rslt['country']= this.extractPropertyFromGeocodingResults(addressComponents, "country");
      }            
      if(placeResult.geometry) {
        rslt['lat']= placeResult.geometry.location.lat();
        rslt['lng']= placeResult.geometry.location.lng();
      }            
      return rslt;      
    },

    extractPropertyFromGeocodingResults(address_components, propName, longname=false) {
      let element = address_components.find(c=>c.types.includes(propName));
      if(element) {
          if(longname) {
              return element.long_name;                    
          }
          else {
              return element.short_name;
          }                
      }
      return "";
    },

    markerdrag(coords) {      
      
      // let rslt = {};
      // rslt['lat'] = coords.latLng.lat;
      // rslt['lng'] = coords.latLng.lng;
      // this.$emit('onresult', rslt);
      this.$emit('onresult', {lat: coords.latLng.lat(), lng: coords.latLng.lng()});
    },

    focusAppointment(poi) {
        this.$emit('focusAppointment', poi);
    },

    getMarkerOptions(poi) {
      const iconUrl = this.markers.normal;
      const baseOptions = poi && poi.markerOptions ? {...poi.markerOptions} : {};
      if (this.mapsApi) {
        const icon = baseOptions.icon && typeof baseOptions.icon === 'object' ? {...baseOptions.icon} : { url: iconUrl };
        icon.url = icon.url || iconUrl;
        icon.labelOrigin = icon.labelOrigin || new this.mapsApi.Point(20, -10);
        baseOptions.icon = icon;
      } else if (!baseOptions.icon) {
        baseOptions.icon = iconUrl;
      }
      return baseOptions;
    },

    getMarkerLabel(poi) {
      const labelText = (poi && (poi.label || poi.code || poi.orderno)) ? (poi.label || poi.code || poi.orderno) : '';
      if(!labelText) {
        return undefined;
      }
      return {
        text: labelText.toString(),
        color: '#D92D20',
        fontSize: '15px',
        fontWeight: '600'
      };
    },

    fitToMarkers(pois = []) {
      if (!this.map || !this.mapsApi || !Array.isArray(pois) || pois.length === 0) {
        return;
      }
      const validCoords = pois
        .map(p => p?.info?.coords)
        .filter(coords => coords && typeof coords.lat === 'number' && typeof coords.lng === 'number');
      if (validCoords.length === 0) {
        return;
      }
      if (validCoords.length === 1) {
        this.map.panTo(validCoords[0]);
        if (this.map.getZoom && this.map.getZoom() > 13) {
          return;
        }
        this.map.setZoom(13);
        return;
      }
      const bounds = new this.mapsApi.LatLngBounds();
      validCoords.forEach(coords => bounds.extend(coords));
      this.map.fitBounds(bounds);
    }
  },

  mounted() {
    if(this.pinCoords.lat && this.pinCoords.lng) {;
      //alert("ENTERED PINCOORDS: " + JSON.stringify(this.pinCoords))
      this.markerPos.lat = this.pinCoords.lat;
      this.markerPos.lng = this.pinCoords.lng;
      this.mapOptions.center.lat = this.pinCoords.lat;
      this.mapOptions.center.lng = this.pinCoords.lng;
    }
  }
}
</script>
<style scoped>
    .omnimapx__wrapper {
      height: 100%;
      padding-bottom: 70px;
      padding-top: 15px;
      background-color: transparent;
    }

    #autocomplete,
    .omnimapx__search {
      border: 2px solid rgba(248, 250, 252, 0.6);
      border-radius: 14px;
      font-size: 18px;
      height: 44px;
      left: 15%;
      padding: 0 18px;
      position: relative;
      clear: both;
      top: 0;
      width: 70%;
      z-index: 1;
      margin-bottom: 15px;
      background-color: rgba(15, 23, 42, 0.75);
      color: #f8fafc;
      outline: none;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
      box-shadow: 0 6px 18px rgba(2, 6, 23, 0.35);
    }

    #autocomplete::placeholder,
    .omnimapx__search::placeholder {
      color: rgba(248, 250, 252, 0.7);
    }

    #autocomplete:focus,
    .omnimapx__search:focus {
      border-color: #f97316;
      box-shadow: 0 8px 22px rgba(249, 115, 22, 0.35);
    }
</style>